import React, { useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { usePropertyId } from '../../common/hooks/usePropertyId';
import { useReservationsData } from '../../common/hooks/useReservationsData';
import { parsePayuPaymentIds } from './components/reservation/reservationUtils';

/**
 * PayU cancelUrl handler. Reverts the attempted PayU payment(s) and redirects to checkout.
 */
const PayuPaymentFailurePage = () => {
  const { reservationId } = useParams();
  const [searchParams] = useSearchParams();
  const propertyId = usePropertyId();
  const navigate = useNavigate();
  const { abandonPayment } = useReservationsData(propertyId, reservationId);
  const handled = useRef(false);

  useEffect(() => {
    if (!reservationId || !propertyId || handled.current) return;
    handled.current = true;

    const paymentIds = parsePayuPaymentIds(searchParams.get('paymentId'));

    (async () => {
      try {
        await abandonPayment(
          reservationId,
          paymentIds.length > 0 ? paymentIds : undefined
        );
      } catch {
        // Still redirect — order may already be DRAFT (idempotent endpoint).
      }
      navigate(`/reservation/${reservationId}/checkout?error=payment_failed`, { replace: true });
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8, gap: 2 }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Anulowanie płatności…
      </Typography>
    </Box>
  );
};

export default PayuPaymentFailurePage;
